import { render, staticRenderFns } from "./ModalNotPossible.vue?vue&type=template&id=5dc6e55a"
import script from "./ModalNotPossible.vue?vue&type=script&lang=js"
export * from "./ModalNotPossible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports